import { invokeApi } from ".";
import * as endPoints from "../constants/ApiEndpoints";
import {
  getFromEncLocalStorage,
  storeInEncLocalStorage,
} from "../helpers/Utils/Utils";

export const getDivisionList = async () => {
  const token = await getFromEncLocalStorage("token");
  const data = await invokeApi(endPoints.getDivisionApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  });

  return data;
};

export const getPlatformList = async (divisionId) => {
  const token = await getFromEncLocalStorage("token");
  const data = await invokeApi(endPoints.getPlatformApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    payload: {
      division_id: divisionId,
    },
  });

  return data;
};

export const getSystemList = async (divisionId) => {
  const token = await getFromEncLocalStorage("token");
  const emailId = await getFromEncLocalStorage("emailId");
  const data = await invokeApi(endPoints.getSystemApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    payload: {
      division_id: divisionId,
      email_id: emailId,
    },
  });

  return data;
};

export const getSubSystemList = async (systemId) => {
  const token = await getFromEncLocalStorage("token");
  const data = await invokeApi(endPoints.getSubSystemApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    payload: {
      system_id: systemId,
    },
  });

  return data;
};

export const addAnswer = async (answerData) => {
  const token = await getFromEncLocalStorage("token");
  const data = await invokeApi(endPoints.addAnswerApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    payload: answerData,
  });

  return data;
};

export const addComment = async (commentData) => {
  const token = await getFromEncLocalStorage("token");
  const data = await invokeApi(endPoints.addCommentApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    payload: commentData,
  });

  return data;
};

export const addLike = async (likeData) => {
  const token = await getFromEncLocalStorage("token");
  const data = await invokeApi(endPoints.likeApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    payload: likeData,
  });

  return data;
};

export const getCreatorList = async (word) => {
  const token = await getFromEncLocalStorage("token");
  const data = await invokeApi(endPoints.getCreatorsApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    payload: word,
  });

  return data;
};

export const getProfileDetails = async () => {
  const token = await getFromEncLocalStorage("token");
  const data = await invokeApi(endPoints.getProfileDetailsApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  });

  return data;
};

export const downloadBlob = async (url) => {
  const SASTokenTime = getFromEncLocalStorage("SASTokenTime");
  const SASToken = getFromEncLocalStorage("SASToken");

  console.log("SASTokenTime: ", SASTokenTime);
  console.log("SASToken: ", SASToken);
  console.log("url: ", url);

  if (new Date() < new Date(SASTokenTime)) {
    return `${url}${SASToken}`;
  } else {
    const SASTokenNew = await saveSASToken();
    // const SASTokenNew = getFromEncLocalStorage("SASToken");
    console.log("SASTokenNew: ", SASTokenNew);
    if (SASTokenNew) {
      return `${url}${SASTokenNew}`;
    } else {
      return `${url}`;
    }
  }

  //   let myHeaders = new Headers();
  // myHeaders.append("accountname", "kmsmediasvcstorage");
  // myHeaders.append("Content-Type", "application/json");

  //   let raw = JSON.stringify({
  //     "url": url,
  //     // "url": "https://epcfrmstoragenew.blob.core.windows.net/epctest/Banner_11012022.jpg",
  //     "urlType" : "base64"
  //   });

  //   let requestOptions = {
  //     method: 'POST',
  //     headers: myHeaders,
  //     body: raw,
  //     redirect: 'follow'
  //   };

  //   let data = await fetch("https://mobilityservices.mahindra.com/azure/v2/downloadBlobs", requestOptions)
  //   let response = await data.text();
  //   return response;
  //   // .then(response => response.text())

  //   // .then(result => {
  //   //   console.log('result-------------', result);
  //   //   return result;
  //   // })
  //   // .catch(error => console.log('error', error));
  //   // console.log(data)
  // //   try {
  // //     let data = await fetch("https://mobilityservices.mahindra.com/azure/v2/downloadBlobs", requestOptions)

  // //     console.log(data);
  // //     return data;
  // // } catch (error) {
  // //     console.error(error);
  // // }
};

let isFetchingSASToken = false;
// const saveSASToken = async () => {
//   let sasTokenResolve;
//   let sasTokenReject;
//   let data;
//   try {
//     const sasTokenPromise = new Promise((resolve, reject) => {
//       sasTokenResolve = resolve;
//       sasTokenReject = reject;
//     });

//     if (!isFetchingSASToken) {
//       isFetchingSASToken = true;

//       const token = getFromEncLocalStorage("token");
//       data = await invokeApi(endPoints.getToken, {
//         method: "POST",
//         headers: {
//           Authorization: token,
//           "Content-Type": "application/json",
//         },
//       });

//       if (!(typeof data == "string")) {
//         debugger;
//         return false;
//       }
//       storeInEncLocalStorage("SASToken", data);
//       const time = new Date();

//       const mins = time.getMinutes();

//       time.setMinutes(mins + 2);
//       storeInEncLocalStorage("SASTokenTime", time.toString());
//       sasTokenResolve();
//     } else {
//       await sasTokenPromise;
//     }

//     return data;
//   } catch (err) {
//     sasTokenReject();
//     return false;
//   } finally {
//     isFetchingSASToken = false;
//   }
// };

const saveSASToken = async () => {
  try {
    const token = getFromEncLocalStorage("token");
    const data = await invokeApi(endPoints.getToken, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });

    if (!(typeof data == "string")) {
      debugger;
      return false;
    }
    storeInEncLocalStorage("SASToken", data);
    const time = new Date();

    const mins = time.getMinutes();

    time.setMinutes(mins + 2);
    storeInEncLocalStorage("SASTokenTime", time.toString());

    return data;
  } catch (err) {
    return false;
  } finally {
    isFetchingSASToken = false;
  }
};

const getCurrentMonthStart = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1);
};

const getCurrentMonthEnd = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth() + 1, 0); // Last day of current month
};

const CommonService = {
  getDivisionList,
  getPlatformList,
  getSystemList,
  getSubSystemList,
  addAnswer,
  addComment,
  addLike,
  getCreatorList,
  getProfileDetails,
  downloadBlob,
  saveSASToken,
  getCurrentMonthStart,
  getCurrentMonthEnd,
};
export default CommonService;
